/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    //My Company
    getCompanyList(params) {
        return HttpService.get(environment.API_MY_COMPANY, {
            params,
        });
    },
    getCompanyById(id) {
        return HttpService.get(environment.API_MY_COMPANY + `/${id}`);
    },

    createCompany(payload) {
        return HttpService.post(environment.API_MY_COMPANY, payload);
    },

    updateCompany(payload) {
        return HttpService.put(environment.API_MY_COMPANY, payload);
    },

    deleteCompany(id) {
        return HttpService.delete(environment.API_MY_COMPANY + `/${id}`);
    },

    //Domain
    getDomainList(params) {
        return HttpService.get(environment.API_MY_COMPANY + '/domain', {
            params,
        });
    },

    createDomain(payload) {
        return HttpService.post(
            environment.API_MY_COMPANY + '/domain',
            payload
        );
    },

    updateDomain(payload) {
        return HttpService.put(environment.API_MY_COMPANY + '/domain', payload);
    },

    checkDomainUsage(id) {
        return HttpService.get(
            environment.API_WFSECURE + `/check/domain/usage/${id}`
        );
    },
    deleteDomain(id) {
        return HttpService.delete(environment.API_WFSECURE + `/domain/${id}`);
    },
};
